import Vue from "vue";
import Router from "vue-router";
import CompanyHome from "@/views/CompanyHome.vue";
import AlipayRealname from "@/views/AlipayRealname.vue";
import AlipayIdImageUpdate from "@/views/AlipayIdImageUpdate.vue";
import AlipayFlowHome from "@/views/AlipayFlowHome.vue";
import AlipayFlowSearch from "@/views/AlipayFlowSearch.vue";
import AlipayFlowResult from "@/views/AlipayFlowResult.vue";
import AlipayFlowSpace from "@/views/AlipayFlowSpace.vue";
import AlipayMyPage from "@/views/AlipayMyPage.vue";
import AlipaySettingsPage from "@/views/AlipaySettingsPage.vue";
import AlipayAccountSecurityPage from "@/views/AlipayAccountSecurityPage.vue";
import AlipayIdentityInfoPage from "@/views/AlipayIdentityInfoPage.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    { path: "/", component: CompanyHome },
    { path: "/alipay-flow", name: "AlipayFlowHome", component: AlipayFlowHome },
    { path: "/alipay-flow/search", name: "AlipayFlowSearch", component: AlipayFlowSearch },
    { path: "/alipay-flow/result", name: "AlipayFlowResult", component: AlipayFlowResult },
    { path: "/alipay-flow/space", name: "AlipayFlowSpace", component: AlipayFlowSpace },
    { path: "/alipay-flow/my", name: "AlipayMyPage", component: AlipayMyPage },
    { path: "/alipay-flow/settings", name: "AlipaySettingsPage", component: AlipaySettingsPage },
    { path: "/alipay-flow/account-security", name: "AlipayAccountSecurityPage", component: AlipayAccountSecurityPage },
    { path: "/alipay-flow/identity-info", name: "AlipayIdentityInfoPage", component: AlipayIdentityInfoPage },
    {
      path: "/UserInfo",
      name: "Alipay",
      component: AlipayRealname
    },
    {
      path: "/IdCard",
      name: "AlipayIdImageUpdate",
      component: AlipayIdImageUpdate
    },
    {
      path: '/:asin',
      name: 'CompanyHomeAsin',
      component: () => import('../views/CompanyHomeAsin.vue')
    }
  ],
});
